import React, { forwardRef } from 'react';

interface FormInputProps {
  label: string;
  value: string | number;
  onChange: (value: string | number) => void;
  type?: 'text' | 'number';
  required?: boolean;
  placeholder?: string;
  step?: string;
  min?: string;
  disabled?: boolean;
  hideLabel?: boolean;
}

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  (
    {
      label,
      value,
      onChange,
      type = 'text',
      required = false,
      placeholder,
      step,
      min,
      disabled = false,
      hideLabel = false,
    },
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (type === 'number') {
        const value = e.target.value;
        if (value === '') {
          onChange(0);
        } else {
          const newValue = parseFloat(value);
          if (!isNaN(newValue)) {
            onChange(newValue);
          }
        }
      } else {
        onChange(e.target.value);
      }
    };

    return (
      <div>
        <label
          className={
            hideLabel ? 'sr-only' : 'block text-sm font-medium text-slate-700 dark:text-slate-200'
          }
        >
          {label}
        </label>
        <input
          ref={ref}
          type={type}
          value={type === 'number' && value === 0 ? '' : value}
          onChange={handleChange}
          required={required}
          placeholder={placeholder}
          step={step}
          min={min}
          disabled={disabled}
          className="mt-1 block w-full rounded-md border-slate-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-70 dark:border-surface-600 dark:bg-surface-800 dark:text-white sm:text-sm"
        />
      </div>
    );
  }
);
